export default "__VITE_ASSET__dad17149__"